import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tag from '../Tags/Tag';
import * as color from '../../sass/color.scss';

/**
 * Get the style for the flight status tag
 */
function getStatusStyle(status) {
  switch (status) {
    case 'confirmed':
      return {
        backgroundColor: color.success16,
        color: color.success,
      };

    case 'unconfirmed':
      return {
        backgroundColor: color.error16,
        color: color.error,
      };

    case 'computing':
    default:
      return {
        backgroundColor: color.orange16,
        color: color.orange,
      };
  }
}

function FlightStatus({
  className = '',
  style = {},
  status,
}) {
  const statusStyle = getStatusStyle(status);

  return (
    <Tag
      className={classNames('FlightStatus', className)}
      tag={{
        name: status,
      }}
      style={{
        display: 'inline-flex',
        justifyContent: 'center',
        fontSize: 10,
        textTransform: 'uppercase',
        backgroundColor: statusStyle.backgroundColor,
        color: statusStyle.color,
        ...style,
      }}
    />
  );
}

FlightStatus.propTypes = {
  className: PropTypes.string,
  style: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  status: PropTypes.string.isRequired,
};

export default FlightStatus;
